var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"partner-registry"}},[_c('registry',{attrs:{"tableFields":_vm.tableFields,"filterList":_vm.filterList,"onSearchItems":_vm.onSearchItemsText,"showProviderDeatils":_vm.showDeatils,"registryType":_vm.registryType,"title":_vm.title,"userType":_vm.userType,"isLoading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }